module.exports = __webpack_public_path__ + "img/20200613_093314.ed54de5d.jpg";